import { ONLY_NUMBER_AND_SPCIAL_CHARACTERES, ONLY_NUMBER_AND_LETTERS, ONLY_NUMBER_AND_LETTERS_URL } from './regexes'
import { isValidRut } from './rut-utils'

/**
 * Check if the given value has only numbers and special characters.
 */
export const checkErrorOnlySpecialCharactersAndNumbers = (value, customMessage) => {
  const isValid = ONLY_NUMBER_AND_SPCIAL_CHARACTERES.test(value)
  return customMessage || isValid ? '' : 'Este campo debe contener únicamente caracteres especiales y números'
}

/**
 * Check if the given value has only numbers and letters.
 */
export const checkErrorOnlyLettersAndNumbers = (value, customMessage) => {
  const isValid = ONLY_NUMBER_AND_LETTERS.test(value)
  return isValid ? '' : customMessage || 'Este campo debe contener únicamente letras y números'
}

/**
 * Check if the given string value is a valid Rut.
 */
export const checkInputNationalDniError = (value, customMessage) => {
  const isValid = value === '' ? true : isValidRut(value)
  return isValid ? '' : customMessage || 'Este campo debe contener un Rut valido'
}

/**
 * Check if the given phone number starts with one of the specified numbers.
 * @param {string} customMessage - The custom error message to display if validation fails.
 * @param {Array} startsWith - An array of numbers the phone number should start with.
 * @return {function} - A function that takes a value and returns an error message if validation fails.
 */
export const checkInputErrorStartsWith = (customMessage, startsWith) => value => {
  const startsWithPattern = new RegExp(`^[${startsWith.join('')}]`)
  return startsWithPattern.test(value) ? '' : customMessage
}

/**
 * Check if the given value is an URL with only letters and numbers.
 */
export const checkInputErrorUrl = customMessage => value => {
  return ONLY_NUMBER_AND_LETTERS_URL.test(value) ? '' : customMessage
}

/**
 * Check max date.
 */
export const checkErrorMaxDateTyping = (value, maxDate) => {
  return new Date(value) <= new Date(maxDate)
}

/**
 * Check max date.
 */
export const checkInputMaxDateTyping = (maxDate, customMessage) => value =>
  checkErrorMaxDateTyping(value, maxDate)
    ? ''
    : customMessage || 'La fecha inicio no puede ser posterior a la fecha de fin.'

/**
 * Check min date.
 */
export const checkErrorMinDateTyping = (value, minDate) => {
  return new Date(value) >= new Date(minDate)
}

/**
 * Check min date.
 */
export const checkInputMinDateTyping = (minDate, customMessage) => value =>
  checkErrorMinDateTyping(value, minDate)
    ? ''
    : customMessage || 'La fecha fin no puede ser anterior a la fecha de inicio.'
